import * as yup from "yup";

export const schema = yup.object().shape({
  price: yup.string().required().matches(/^[0-9.]+$/, "Must be number"),
  minqty: yup.string().required().matches(/^[0-9]+$/, "Must be number"),
  is_price_visible: yup.boolean().default(true),
  is_active: yup.boolean().default(true),
  in_stock: yup.boolean().default(true),
});

export const getTextfieldData1 = (price) => [
  {
    label: "Price",
    value: price,
    onChangeField: "price",
  },
];

export const getTextfieldData2 = (minqty) => [
  {
    label: "Minimum Qty",
    value: minqty,
    onChangeField: "minqty",
  },
];

export const getCheckboxData1 = (is_price_visible, is_price_onunlock) => [
  {
    label: "Show price on site",
    value: is_price_visible,
    onChangeField: "is_price_visible",
  },
  {
    label: "Only on Like!",
    value: is_price_onunlock,
    onChangeField: "is_price_onunlock",
  },
];

export const getCheckboxData2 = (is_listing_active, in_stock) => [
  {
    label: "Active on site",
    value: is_listing_active,
    onChangeField: "is_listing_active",
  },
  {
    label: "Show as 'In stock''",
    value: in_stock,
    onChangeField: "in_stock",
  },
];

export const getCheckboxSizeLetters = (XS, S, M, L, XL, XXL, XXXL, XXXXL) => [
  {
    label: "XS",
    value: XS,
    onChangeField: "XS",
  },
  {
    label: "S",
    value: S,
    onChangeField: "S",
  },
  {
    label: "M",
    value: M,
    onChangeField: "M",
  },
  {
    label: "L",
    value: L,
    onChangeField: "L",
  },
  {
    label: "XL",
    value: XL,
    onChangeField: "XL",
  },
  {
    label: "XXL",
    value: XXL,
    onChangeField: "XXL",
  },
  {
    label: "XXXL",
    value: XXXL,
    onChangeField: "XXXL",
  },
  {
    label: "XXXXL",
    value: XXXXL,
    onChangeField: "XXXXL",
  },
];

export const getCheckboxSizeNumbers = (SIZE_24, SIZE_26, SIZE_28, SIZE_30, SIZE_32, SIZE_34, SIZE_36, SIZE_38, SIZE_40, SIZE_42) => [
  {
    label: "24",
    value: SIZE_24,
    onChangeField: "24",
  },
  {
    label: "26",
    value: SIZE_26,
    onChangeField: "26",
  },
  {
    label: "28",
    value: SIZE_28,
    onChangeField: "28",
  },
  {
    label: "30",
    value: SIZE_30,
    onChangeField: "30",
  },
  {
    label: "32",
    value: SIZE_32,
    onChangeField: "32",
  },
  {
    label: "34",
    value: SIZE_34,
    onChangeField: "34",
  },
  {
    label: "36",
    value: SIZE_36,
    onChangeField: "36",
  },
  {
    label: "38",
    value: SIZE_38,
    onChangeField: "38",
  },
  {
    label: "40",
    value: SIZE_40,
    onChangeField: "40",
  },
  {
    label: "42",
    value: SIZE_42,
    onChangeField: "42",
  },
];

export const getButtonData = (onFinish, cancelEdit, hasError, isTouched) => [
  {
    name: "Save",
    onClick: onFinish,
    variant: "contained",
    type: "primary",
    disabled: hasError() || !isTouched(),
  },
  {
    name: "Cancel",
    onClick: cancelEdit,
    variant: "outlined",
    type: "primary",
    disabled: false,
  },
];
